var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThSuccessHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4078 7.67327L16.7528 4.11997C16.8893 2.69205 18.2227 1.7231 19.5697 2.07108C21.5961 2.59605 23.0195 4.47845 23.0195 6.63683V11.1891C23.0195 12.2015 23.0195 12.7085 23.2385 13.079C23.363 13.2905 23.5339 13.4689 23.7379 13.5964C24.0979 13.8229 24.5884 13.8229 25.5678 13.8229H26.1618C28.7162 13.8229 29.9926 13.8229 30.7785 14.4079C31.368 14.8474 31.7835 15.4908 31.9485 16.2198C32.1675 17.1947 31.677 18.4142 30.6945 20.85L30.2056 22.065C29.922 22.7686 29.8059 23.5286 29.8666 24.2848C30.2146 28.5956 26.7963 32.2269 22.6175 31.9884L6.98237 31.09C5.27396 30.9925 4.42051 30.943 3.64955 30.2605C2.8771 29.578 2.73161 28.8746 2.44212 27.4692C1.826 24.4792 1.85413 21.3924 2.52462 18.4142C2.94909 16.5423 4.73699 15.5343 6.58339 15.7743C11.4791 16.4043 15.9174 12.746 16.4078 7.67477V7.67327Z",
    stroke: "#337D98",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49692 16.25L9.29143 16.9355C7.96116 21.3699 8.03293 26.1071 9.49692 30.4992",
    stroke: "#337D98",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThSuccessHand);
export default __webpack_public_path__ + "static/media/TH-Success-Hand.c017ab601adb2df2565ba5cfd87e53aa.svg";
export { ForwardRef as ReactComponent };